module.exports = __webpack_public_path__ + "img/1.cf0b46cd.png";